<template>
  <div v-if="!updateVar" >
    <b-card-group columns class="mb-4 text-center">
      <b-card v-for="(item, key) in dnsModel"
              :keys="key"
              v-if="filter.general.includes(key)">
        <b>{{$t('dns')[key]}}</b>
        <h3>{{item}}</h3>
      </b-card>
    </b-card-group>
    <b-card >
      <b-button class="col-12 mb-4 mt-2"
                v-if="!edit"
                @click="editObj">
        Editieren
      </b-button>
      <b-button v-if="edit"
                class="col-12 mb-4 mt-2"
                @click="undoObj">
        Abbrechen
      </b-button>
      <b-container style="margin-left: auto; margin-right: auto; max-width: 600px;">
        <b-input-group  v-for="(item, key) in dnsModel"
                        :keys="key"
                        :prepend="$t('dns')[key]"
                        class="mb-2 mt-2"
                        v-if="filter.editable.includes(key)">
          <b-input v-if="edit"
                   @input="changedObj"
                   :placeholder="item"
                   v-model="dnsModel[key]" >
          </b-input>
          <p class="ml-3 form-control-plaintext" v-else > {{item}} </p>
        </b-input-group>
      </b-container>

      <hr>
      <b-button class="col-12"
                @click="newRecord = !newRecord">
        {{newRecord ? 'Abbrechen' : 'Neuen Eintrag hinzufügen'}}
      </b-button>
      <div v-if="newRecord"  >

        <b-table :fields="newRecordFields" :items="newRecordObj">
            <template v-for="(item,key) in newRecordObj[0]" :slot="key">
              <select v-if="key === 'type'"
                      v-model="newRecordObj[0]['type']"
                      style="min-width: 100px; min-height: 35px;">
                <option v-for="(el,x) in ['A','AAAA','CNAME','MX','SRV','TXT','CAA','PTR','NS']"
                        :value="el"
                        :key="x">
                  {{el}}
                </option>
              </select>
              <b-input v-else
                       v-model="newRecordObj[0][key]">
              </b-input>
            </template>

            <template slot="saverow">
              <b-button @click="addNewRecord(newRecordObj[0],$forceUpdate())"
                        variant="outline-success">
                Hinzufügen
              </b-button>
            </template>
        </b-table>
      </div>
      <hr>
    </b-card>

    <b-card class="mt-4 mb-4">
      <b-input-group>
        <b-input v-model="search"
                 placeholder="Eintrag suchen"
                 style="min-width: 258px;">
        </b-input>
        <b-input-group-append>
          <b-button size="sm"
                    variant="default"
                    class="pl-4 pr-4"
                    @click="search = null">
            <i class="fa fa-close"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-card>

    <b-card style="min-width: 810px;"
            class="pb-5 mt-4"
            v-if="records">
      <b-table :items="searchResult ? searchResult :records"
               :fields="fields"
               select-mode="single"
               selectable
               stripped
               @row-selected="editRow">
        <template slot="name" slot-scope="{ index ,item }">
          <b-input v-if="item && selectedRow === item.$id"
                   @input="changedRow"
                   v-model="records[index]['name']">
          </b-input>
          <div v-else>
            {{item.name}}
          </div>
        </template>
        <template slot="type" slot-scope="{ index ,item }">
          <select id="type"
                  v-model="records[index]['type']"
                  style="min-width: 100px; min-height: 35px;"
                  @change="changedRow"
                  v-if="item && selectedRow === item.$id">
            <option v-for="(el,x) in ['A','AAAA','CNAME','MX','SRV','TXT','CAA','PTR','NS']"
                    :value="el"
                    :key="x">
              {{el}}
            </option>
          </select>
          <div v-else>
            {{item.type}}
          </div>
        </template>
        <template slot="data" slot-scope="{ index ,item }">
          <b-input v-if="item && selectedRow === item.$id"
                   v-model="records[index]['data']"
                   @input="changedRow">
          </b-input>
          <div  v-else
                style="display:block;max-width: 150px;">{{item.data}}</div>
        </template>
        <template slot="ttl" slot-scope="{ index ,item }">
          <b-input v-if="item && selectedRow === item.$id"
                   v-model="records[index]['ttl']"
                   @input="changedRow">
          </b-input>
          <div v-else>
            {{item.ttl}}
          </div>
        </template>
        <template slot="deleterow" slot-scope="{ index ,item }">
          <b-link  @click="deleteNewRecord(item)"> Entfernen
          </b-link>
        </template>
      </b-table>
    </b-card>
    <br>
    <br>
    <br>

    <b-row class="fixed-bottom footer-summary" v-if="localChange">
      <b-col>
        <b-button class="col-12"
                  @click="saveAllChangesToBackend()"
                  variant="primary" >
          <h3 v-if="!spinner">Änderungen speichern</h3>
          <b-spinner v-else></b-spinner>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {NameserverZone} from "@/store/models/dns/nameserver_zone";
import {NameserverRecords} from "@/store/models/dns/nameserver_records";
import axios from "@/store/vue-axios"

  export default {
      name: "luma-dns-single",
      data:()=>({
          spinner : false,
          updateVar:false,
          localChange:false,
          records:[],
          search:'',
          selectedRow:0,
          edit:false,
          dnsObj: null,
          newRecordObj:[{name:'0',type:'0',data:'0',ttl:'0'}],
          newRecord:false
      }),
      computed:{
          newRecordFields(){
              return [
                  {key:'name',label:'NAME',sortable:true},
                  {key:'type',label:'TYPE',sortable:true},
                  {key:'data',label:'DATA',sortable:true},
                  {key:'ttl',label:'TTL',sortable:true},
                  {key:'saverow',label:'HINZUFÜGEN',sortable:false}
              ]
          },
          fields(){
              return [
                  // {key:'$id',label:'ID',sortable:true},
                  {key:'name',label:'NAME',sortable:true},
                  {key:'type',label:'TYPE',sortable:true},
                  {key:'data',label:'DATA',sortable:true},
                  {key:'ttl',label:'TTL',sortable:true},
                  {key:'created_at',label:'ERSTELLT',sortable:true},
                  {key:'updated_at',label:'UPDATE',sortable:true},
                  {key:'deleterow',label:'ENTFERNEN',sortable:false},
                  // {key:'saverow',label:'SPEICHERN',sortable:false}
              ]
          },
          filter(){
              return {
                  general:[
                    'id',
                    'name',
                    'serial'
                  ],
                  editable:[
                    'hostmaster',
                    'refresh',
                    'retry',
                    'expire',
                    'ttl',
                    'ns_first',
                    'ns_second'
                  ],
                  dates:[
                      'created_at',
                      'updated_at',
                      'expire'
                  ]
              }
          },
          dns(){
              return this.$route.params.name
          },
          dnsModel(){
              return this.dnsObj
          },
          searchResult(){
            if(this.search){
              const searchlist=[]
              const searchindexes = []
              NameserverRecords.all().map(el=>{
                 el.name.includes(this.search) || el.data.includes(this.search) || el.type.includes(this.search) || el.data.includes(this.search)  ? searchlist.push(el) : undefined
              })
              searchlist.map((el,index)=>{
                this.records.map((n,i)=>{
                  n.$id === el.$id ? searchindexes.push(i) : undefined
                })
              })
              return searchindexes.map(el=>this.records[el])
            }
          }

      },
      methods:{
        addNewRecord(val){
          console.log('NEW RECORD :::',val)
          NameserverRecords.insertOrUpdate({data:val})
          this.records = null
          this.records = JSON.parse(JSON.stringify(NameserverRecords.all().map(el=>(Object.assign({},el)))))
          this.localChange = true
        },
        deleteNewRecord(val){
          this.selectedRow = 0
          console.log('DEL NEW RECORD:::',val)
          NameserverRecords.delete(val.$id)
          this.records = null
          this.records = JSON.parse(JSON.stringify(NameserverRecords.all().map(el=>(Object.assign({},el)))))
          this.localChange = true

        },
        editObj(){
          this.edit = true
        },
        undoObj(){
          this.edit = false
          const records = this.dnsObj.records
          this.dnsObj = Object.assign({},NameserverZone.find(this.dns))
          // delete this.dnsObj.records
          this.dnsObj.records = records
        },
        changedObj() {
          this.localChange = true
        },
        changedRow(item){
          this.localChange = true
        },
        editRow(input){
          this.selectedRow = input[0].$id ? input[0].$id : undefined
        },
        updateAll(){
          this.updateVar = true
          this.localChange = false
          NameserverZone.fetch(this.dns)
          this.dnsObj = null
          this.dnsObj = Object.assign({},NameserverZone.find(this.dns))
          NameserverRecords.deleteAll()
          NameserverRecords.insertOrUpdate({data:this.dnsObj.records})
          this.records = null
          this.records = JSON.parse(JSON.stringify(NameserverRecords.all().map(el=>(Object.assign({},el)))))
          const x = setTimeout(()=>{this.updateVar = false},200)

        },
        saveAllChangesToBackend(){
          this.spinner = true
          const dnsObj = Object.assign({},this.dnsObj)
          delete dnsObj.records
          dnsObj['records'] = this.records
          dnsObj['zone'] = dnsObj.name
          console.log('COMPLETE OBJ:::',dnsObj)
          const x = axios.put("/dns/zones/update",dnsObj).then(
            response=>{

              this.updateAll()
              this.spinner = false
            }
          ).catch(
            error => error
          )

        }
      },
      created(){
        this.updateAll()
      }

  }
</script>
<style>
  .inputfield{
    min-width: 120px;
    max-width: 200px;
  }
  .input-group-text{
    min-width: 180px;
  }
  .footer-summary {
    margin-left: 220px;
    z-index: 1000;
    padding: 20px;
    bottom: 0px;
    background: white;
    box-shadow: 0 -1px 5px rgba(0,0,0,.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/dns/single_dns/luma-dns-single.vue